import { CheckCircle } from "@phosphor-icons/react";

/**
 * Header shown on top of the "Nuovo Movimento" modal when the operator is
 * fulfilling a transfer order (ODT). Includes:
 *   - the green "Evasione ODT in corso" instructional banner
 *   - the step progress indicator ("ODT · Prodotto X di Y") with a progress bar
 *
 * `confirmedCount` is the number of items already pushed to bulkItems and
 * `totalCount` is the full ODT size (0 means not an ODT fulfilment).
 */
export default function ODTWizardStep({ transferOrderId, confirmedCount, totalCount }) {
  if (!transferOrderId && totalCount <= 1) return null;
  return (
    <>
      {transferOrderId && (
        <div className="mt-2 flex items-start gap-2 border border-emerald-300 bg-emerald-50 text-emerald-900 px-3 py-2 text-xs" data-testid="odt-fulfilment-banner">
          <CheckCircle size={14} weight="bold" className="mt-0.5 shrink-0" />
          <div className="flex-1">
            <b>Evasione ODT in corso.</b>
            {totalCount > 1 ? (
              <> Compila ogni apparato uno alla volta, poi premi <b>"Prossimo prodotto"</b>. Al termine dell'ultimo premi <b>"Salva movimento ODT"</b>.</>
            ) : (
              <> Compila seriali / quantità e firma. Al salvataggio l'ODT verrà chiuso automaticamente.</>
            )}
          </div>
        </div>
      )}
      {totalCount > 1 && (
        <div className="mt-2" data-testid="odt-wizard-progress">
          <div className="flex items-center justify-between text-xs mb-1">
            <span className="label-eyebrow text-[#002FA7]">
              ODT · Prodotto {confirmedCount + 1} di {totalCount}
            </span>
            <span className="text-neutral-500">
              {confirmedCount}/{totalCount} confermati
            </span>
          </div>
          <div className="h-1.5 bg-neutral-200 overflow-hidden">
            <div className="h-full bg-[#002FA7] transition-all"
                 style={{ width: `${(confirmedCount / totalCount) * 100}%` }} />
          </div>
        </div>
      )}
    </>
  );
}
